import { EventBus } from '@/event'
import { mVMixin } from '@/mixins'

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'

export const reports = {
    state: {
        baseUrl: `https://vtranscode.mobiotics.com/${releaseType}/provider/v1/report`,
        auth: `Bearer ${localStorage.getItem('token')}`
    },
    getters: {},
    mutations: {},
    actions: {
        actGetReport(context, data) {
            console.log(data)
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            EventBus.$emit('Loader', true)
                // var queryParams = new URLSearchParams()
            var queryParams = ''
            var queryParamsValue = ''
            if (data.reportid === "unprocess") {
                let { filename = "", filetype = "" } = data.filter
                queryParams = `originalfilename=${filename}&filetype=${filetype}`
            } else if (data.reportid === "job" || data.reportid === "transcode") {
                let intitiatedBy = context.getters.getReportInitiatedBy ? [{ 'name': 'initiatedby', 'value': context.getters.getReportInitiatedBy }] : []
                data.filter = intitiatedBy.concat(data.filter)
                    // queryParams = `filter=${JSON.stringify(concatedData)}`
                    // console.log(data)
                if (data.filter) {
                    let abc = []
                    data.filter.map(ele => {
                        if (ele) {
                            abc.push(ele)
                        }
                        queryParamsValue = btoa(JSON.stringify(abc))
                    })
                }
            } else if ((data.reportid === "usage")) {
                // console.log(context.getters.getReportInterval)
                if (data.filter) {
                    let abc = []
                    data.filter.map(ele => {
                        if (ele) {
                            abc.push(ele)
                        }
                        queryParamsValue = btoa(JSON.stringify(abc))
                    })
                }
                queryParams = `interval=${context.getters.getReportInterval}`
            } else {
                if (data.filter) {
                    let abc = []
                    data.filter.map(ele => {
                        if (ele) {
                            abc.push(ele)
                        }
                        queryParamsValue = btoa(JSON.stringify(abc))
                    })
                }
            }
            console.log(atob(queryParamsValue))
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/${data.reportid}?&todate=${data.todate}&fromdate=${data.fromdate}&pagesize=${data.pagesize}&page=${data.page}&${queryParams}&filter=${queryParamsValue}`, requestOptions).then(Response => {
                    EventBus.$emit('Loader', false)
                    if (Response.ok) {
                        resolve(Response.json())
                    } else {
                        resolve(Response.json())
                    }
                }).catch(error => {
                    EventBus.$emit('Loader', false)
                    console.log(error)
                    reject(error)
                })
            })
        },
        actReportDownload(context, data) {
            let { id, dates } = data;
            console.log(data, "data")
            let queryParams = ""
            if ((id === "usage")) {
                queryParams = `filter=${JSON.stringify(context.getters.getReportData)}&interval=${context.getters.getReportInterval}`
            } else if (data.reportid === "job" || data.reportid === "transcode") {
                let intitiatedBy = context.getters.getReportInitiatedBy ? [{ 'name': 'initiatedby', 'value': context.getters.getReportInitiatedBy }] : []
                queryParams = intitiatedBy.concat(context.getters.getReportData)
                queryParams = `filter=${JSON.stringify(queryParams)}`
            } else if (id === "unprocess") {
                let { filename = "", filetype = "" } = context.getters.getReportData
                queryParams = `originalfilename=${filename}&filetype=${filetype}`
            } else {
                queryParams = `filter=${JSON.stringify(context.getters.getReportData)}`
            }
            EventBus.$emit('Loader', true)
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/${id}/download?todate=${dates.toDate}&fromdate=${dates.fromDate}&${queryParams}`, {
                    headers: { 'Authorization': context.getters.getAuthToken }
                }).then(Response => {
                    console.log(Response, 'response')
                    EventBus.$emit('Loader', false)
                    if (Response.ok) {
                        resolve(Response.text())
                    } else {
                        resolve(Response.json())
                    }
                }).catch(error => {
                    EventBus.$emit('Loader', false)
                    console.log(error)
                    reject(error)
                })
            })
        },
        actListProvider(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', context.getters.getAuthToken)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            let params = `${mVMixin.methods.getParam(data)}`
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.getters.getloginUrl}/user?${params}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        getProviderSubUser(context, serviceid) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', context.getters.getAuthToken)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getloginUrl}/user/${serviceid}`, requestOptions)
                    .then(response => {
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reports.js